import { AxiosInstance } from "axios";
import { Plan } from "../models/plan";
import { Subscription } from "../models/subscription";

const SUBSCRIPTION_API_PREFIX = "/payments/subscriptions";

export const getUserActiveSubscription = async (
	http: AxiosInstance
): Promise<{ plan: Plan; subscription: Subscription }> => {
	const response = await http.get<{ plan: Plan; subscription: Subscription }>(
		`${SUBSCRIPTION_API_PREFIX}/get-user-active-subscription`
	);

	return response.data;
};

export const cancelSubscription = async (
	http: AxiosInstance,
	subscriptionId: number
): Promise<void> => {
	await http.post(`${SUBSCRIPTION_API_PREFIX}/cancel-subscription`, {
		subscriptionId,
	});
};

export const modifySubscription = async (
	http: AxiosInstance,
	planId: number
): Promise<void> => {
	await http.post(`${SUBSCRIPTION_API_PREFIX}/modify-subscription`, {
		planId,
	});
};
